<template>
  <TrainingProcessLog
    :extra-params="extraParams"
    :visible="visible"
    :extra-id="$attrs['extra-id']"
    api-url="/workspace/manager/training/rejoin/rejoinProcessLog"
    log-type-name="答辩" />
</template>

<script>
import TrainingProcessLog from '../../common/TrainingProcessLog'
export default {
  name: 'TrainingRejoinProcessLog',
  components: {
    TrainingProcessLog
  },
  props: {
    extraParams: Object,
    visible: Boolean
  }
}
</script>
